export { VttThumbnails } from './plugin';
